import { GenericObject, copyFields, fixDates } from '@synergy/models';

import { ProductSnapshot } from './product-snapshot';
import { User } from './user';

export class OfferItem extends ProductSnapshot {
    public override id?: number;
    public override currency!: string;
    public override discount!: number;
    public isOffered!: boolean;
    public isAlternative!: boolean;
    public alternativeNote?: string;
    public isSelected?: boolean;
    public createdBy!: User;
    public updateBy!: User;
    public createdAt!: Date;
    public updatedAt!: Date;

    public static override fromPlainObject(object: GenericObject): OfferItem {
        const offerItem = new OfferItem();

        // Import own keys
        copyFields(object, offerItem);

        // Import from base class (ProductSnapshot)
        const productSnapshot = ProductSnapshot.fromPlainObject(object);

        // Overwrite own keys with base keys
        copyFields(productSnapshot, offerItem);

        if (object['createdBy']) {
            offerItem.createdBy = User.fromPlainObject(object['createdBy']);
        }

        if (object['updateBy']) {
            offerItem.updateBy = User.fromPlainObject(object['updateBy']);
        }

        fixDates(offerItem, ['createdAt', 'updatedAt']);

        return offerItem;
    }
}
